import * as React from 'react'

const DropZoneUploadIcon = props => (
  <svg
    width={32}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.8 9.06C24.893 3.885 20.853 0 16 0c-3.853 0-7.2 2.46-8.867 6.06C3.12 6.54 0 10.365 0 15c0 4.965 3.587 9 8 9h17.333C29.013 24 32 20.64 32 16.5c0-3.96-2.733-7.17-6.2-7.44Zm-7.133 4.44v6h-5.334v-6h-4L16 6l6.667 7.5h-4Z"
      fill="#0B2456"
    />
  </svg>
)

export default DropZoneUploadIcon
